export default __webpack_public_path__ + "3c6e7d1e79bedd817b3a36d3c786bdae.webp";